var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVortexConsumerFinance01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 438 416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#09B2C9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M209.8,189.48h42.08a2.58,2.58,0,0,0,0-5.15H209.8a2.58,2.58,0,1,0,0,5.15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M209.8,197.54h26.43a2.58,2.58,0,0,0,0-5.16H209.8a2.58,2.58,0,0,0,0,5.16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M224.23,200.44H209.8a2.58,2.58,0,1,0,0,5.15h14.43a2.58,2.58,0,0,0,0-5.15Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M213.29,231.88a9,9,0,1,0,9,9A9,9,0,0,0,213.29,231.88Zm0,12.76a3.81,3.81,0,1,1,3.81-3.8A3.8,3.8,0,0,1,213.29,244.64Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M244.43,231.88a9,9,0,1,0,9,9A9,9,0,0,0,244.43,231.88Zm0,12.76a3.81,3.81,0,1,1,3.81-3.8A3.8,3.8,0,0,1,244.43,244.64Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M272.27,172.11a2.58,2.58,0,0,0-2-1H190L188.46,164a2.59,2.59,0,0,0-1.29-1.72l-12.91-7a2.58,2.58,0,0,0-2.45,4.53l11.87,6.43,8.91,41.05,1.25,5.8h0L196.65,226a2.56,2.56,0,0,0,2.51,2h61.68a2.58,2.58,0,1,0,0-5.15h-59.6l-1.68-7.76h61.89a2.58,2.58,0,0,0,2.51-2l8.81-38.86A2.58,2.58,0,0,0,272.27,172.11ZM259.39,210H198.44l-1.09-5-6.23-28.71H267Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M67.09,285.55q39.27,0,78.52.07c17.12,0,34.23,0,51.34.07,1.39,0,2.76,1,4.16,1.51a16.29,16.29,0,0,0,4.55,1.26c10.77.11,21.54.16,32.31,0,1.7,0,3.36-1.35,5.06-2a6.94,6.94,0,0,1,2.44-.74q64.47-.06,129,0c.58,0,1.17.1,1.72.15.65,5.42-4.65,10.56-10.87,10.58-12.38,0-24.76,0-37.15,0q-122.61,0-245.23.12c-4.13,0-7.72-.56-10.81-2.28a9.89,9.89,0,0,1-5-8.67Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M351.67,257.45q0-65.91,0-131.82c0-6.54-3.17-9.59-10-9.59H102.49c-8,0-10.84,2.75-10.85,10.52q0,62.25,0,124.49v6.74c0,6.2,0,12.62,0,18.94,0,2.24.22,3.62,1.15,4.47s2.27,1,4.64,1H221.54l.77,0h24.55c32.67,0,66.45,0,99.67.08h0c3.32,0,4.84-1.38,5.06-4.62,0-.67,0-1.35,0-2Zm-130-138.2a1.55,1.55,0,1,1-1.55,1.54A1.54,1.54,0,0,1,221.65,119.25ZM342.49,272.52H100.83v-147H342.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVortexConsumerFinance01);
export default __webpack_public_path__ + "static/media/Vortex_Consumer_Finance-01.e44c330032ccd4401fa0e2bca345c544.svg";
export { ForwardRef as ReactComponent };